import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useSearchParams,Link } from 'react-router-dom';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { Helmet } from "react-helmet-async";
import { useAuth } from '../../context/AuthContext';
import { db, doc,onSnapshot} from '../../config/firebaseConfig.js'; // Pastikan jalur benar
import { documentId } from 'firebase/firestore';

const RuangUjianPd = () => {
  const { user, loading, logout } = useAuth();

  const location = useLocation();
  const navigate = useNavigate();
 const { kode, nama_mapel,id } = location.state || {};  
 console.log(location.state)



  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const [daftaruji, setUji] = useState({});



 useEffect(() => {
  if (!id) return;
 
  const unsub = onSnapshot(doc(db, "jadwal", id), (docSnap) => {
    if (docSnap.exists()) {
      setUji(docSnap.data())
      console.log("ddd",docSnap.data() );
    }
  });

  return () => unsub();
}, [id]);

function formatTanggal(timestamp) {
  const date = new Date(timestamp.seconds * 1000);

  const hari = date.getDate().toString().padStart(2, "0");
  const bulanPendek = date.toLocaleString("id-ID", { month: "short" });
  const tahun = date.getFullYear().toString().slice(-2);

  const jam = date.getHours().toString().padStart(2, "0");
  const menit = date.getMinutes().toString().padStart(2, "0");

  return {
    tanggal: `${hari} ${bulanPendek} ${tahun}`, // 25 Nov 25
    waktu: `${jam}:${menit}`                    // 09:55
  };
}
  return (
    <div>
      <Helmet>
        <title>Identifikasi Pengguna</title>
      </Helmet>
      <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
        <div className="card  p-4" style={{ width: "100%", maxWidth: "600px" }}>
          <div className="text-center mb-4">
            <img
              src="/assets/images/logogvfix.png"
              width={100}
              alt="Logo"
              className="img-fluid mb-2"
            />
            <h4 className="text-secondary"><b>Hi, <span style={{ textTransform: 'capitalize' }}>{user.nama}</span></b></h4>

          </div>
          <hr />
          <h6>PERSIAPAN UJI</h6>
          <hr />
          <div className="row">

  {/* Kolom Kiri */}
  <div className="col-md-6">
    <div className="border rounded p-3">
      <p className="mb-0">
        <small>Kode:</small> <br />
        <b>{daftaruji.kode}</b>
      </p>
      <hr />
      <p>
        <small>Pelajaran:</small> <br />
        <b>{nama_mapel}</b>
      </p>
       <p className="mb-0">
        <small>Pengawas:</small> <br />
        <b>{daftaruji.nama_pengawas}</b>
      </p>
    </div>
  </div>
   

  {/* Kolom Kanan */}
  <div className="col-md-6">
   <div className="row">

  <div className="col-md-12">
    <div className="border rounded p-3">
      <p>Silahkan Memulai ujian</p>
    </div>
  </div>

  <div className="col-md-12 p-3">

    {/** --------------------------
        CEK APAKAH USER TERDAFTAR
        daftar_peserta: [{ uid: "...", disetujui: true }]
    -------------------------------- */}
    {!daftaruji?.daftar_peserta?.includes(user.uid) ? (
      <p className="text-danger">Belum disetujui Pengawas</p>
    ) : daftaruji.status !== "Aktif" ? (
      <p className="text-danger">Belum dimulai</p>
    ) : (
      <>
        {/** -----------------------------------------
            CEK STATUS PESERTA DI daftaruji.peserta
            peserta: [{ id: "uid", status: "Mulai" }]
        ---------------------------------------------- */}
        {(() => {
          const peserta = daftaruji.peserta.find(
            (p) => p.id?.toString() === user.uid?.toString()
          );

          if (!peserta) {
            return (
              <p className="text-danger">Status peserta tidak ditemukan</p>
            );
          }

          // Jika status adalah "Mulai" → tampilkan tombol mulai
          if (peserta.status === "Mulai") {
            return (
              <Link
                to={`/lembarujian`}
                state={{ kode: kode, id: id,nama_mapel:nama_mapel }}
                className="btn btn-success text-white"
              >
                Mulai
              </Link>
            );
          }

          // Jika status selain "Mulai"
          return (
            <p className="text-danger">{peserta.status}</p>
          );
        })()}
      </>
    )}

  </div>
</div>

  </div>

</div>

          {error && <div className="alert alert-danger mt-2">{error}</div>}
          {successMessage && <div className="alert alert-success mt-2">{successMessage}</div>}


        </div>
      </div>
    </div>
  );
};

export default RuangUjianPd;
